import Header_lottie_btn_animation from '../../../animations/header_lottie_btn_animation/Header_lottie_btn_animation'
import "./Header_lottie_btn.css"

function Header_lottie_btn({ animationData, onClick }) {
    return (
        <>
            <section className='Header_lottie_btn' onClick={onClick}>
                <Header_lottie_btn_animation animationData={animationData} />
            </section>
        </>
    )
}

export default Header_lottie_btn